const ares_url = process.env.REACT_APP_URL_ARES;

export async function getAresData(ico: string): Promise<any | null> {
	try {
		const res = await fetch(ares_url + ico, {
			method: 'GET',
		});

		return {
			response: res,
			data: await res.json()
		};
	} catch (err) {
		return null;
	}
}
